import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import elementJaLocale from 'element-ui/lib/locale/lang/ja'// element-ui lang
import elementRuLocale from 'element-ui/lib/locale/lang/ru-RU'// element-ui lang
import elementThLocale from 'element-ui/lib/locale/lang/th'
import elementViLocale from 'element-ui/lib/locale/lang/vi'
import { i18nChangeLanguage } from '@wangeditor/editor'
import enLocale from './en'
import zhLocale from './zh'
import jaLocale from './ja'
import ruLocale from './ru'
import thLocale from './th'
import viLocale from './vi'

Vue.use(VueI18n)

const locale = Cookies.get('language') || 'zh'

if (locale !== 'zh') {
  i18nChangeLanguage('en')
}

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  },
  ja: {
    ...jaLocale,
    ...elementJaLocale
  },
  ru: {
    ...ruLocale,
    ...elementRuLocale
  },
  th: {
    ...thLocale,
    ...elementThLocale
  },
  vi: {
    ...viLocale,
    ...elementViLocale
  }
}

const i18n = new VueI18n({
  // set locale
  // options: en | zh | ja
  locale,
  // set locale messages
  messages
})

export default i18n
